import Promise from 'nuo'
import global from './_global'

global.Promise = Promise



// WEBPACK FOOTER //
// ./src/polyfills/promise.js